import React from 'react';

export default () => {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="30" height="30" rx="5" fill="#F4F4F4"/>
            <rect x="8.5" y="8.5" width="13" height="13" rx="3" fill="#CC0000"/>
        </svg>
    );
};
